import { AnimatePresence, motion } from 'framer-motion'

import { commonIcons } from '@apps-common/config/icons'
import { motionFadeIn } from '@apps-common/config/motion-variants'
import { useMemo } from 'react'

interface IProps {
  filter: any
  filterKeyWordsFunc: () => string[]
  callback: () => void
  withContainer?: boolean
}

export const PageClearFilterButton: React.FC<IProps> = ({ filter, filterKeyWordsFunc, callback, withContainer }) => {
  const isFiltered = useMemo(() => filterKeyWordsFunc().length > 0, [filter, filterKeyWordsFunc])

  return (
    <AnimatePresence>
      {isFiltered && (
        <motion.div key='page-body-clear-filter-button' {...motionFadeIn(0.25)}>
          {withContainer && (
            <div className='flex items-center justify-end'>
              <PageClearFilterButton filter={filter} filterKeyWordsFunc={filter.getFilteredByKeywords} callback={filter.clear} />
            </div>
          )}
          {!withContainer && (
            <button type='button' className='action-brand jost-medium text-[0.75rem] pl-2 pr-1' onClick={() => callback()}>
              Clear filter
              <commonIcons.remove className='text-[0.95rem]' />
            </button>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
